/**
 * GET Search Users Async
 * @returns promise Search Users
 */
import api_url from "./ApiUrl";

export const getSearchUsersAsync = async (token, searchUser) => {
  const requestOptions = {
    method: "GET",
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
  };
  try {
    let promise = await fetch(
      `${api_url}/users/search?search=${searchUser}`,
      requestOptions
    );
    if(promise.status === 200){
      let results = await promise.json();
      return results;
    }
  } catch (error) {
    console.log(error);
  }
};